const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M10.36 3.066a.75.75 0 0 1-.001.87 6.958 6.958 0 0 0 9.705 9.705.75.75 0 0 1 1.156.82 9.422 9.422 0 0 1-18.47-2.632c0-4.291 2.868-7.91 6.79-9.05a.75.75 0 0 1 .82.287m-2.268 1.97a7.922 7.922 0 1 0 10.871 10.872A8.458 8.458 0 0 1 8.092 5.036" clip-rule="evenodd"/></svg>';
export {
  e as w
};
